document.addEventListener('DOMContentLoaded', function () {
  var radios = document.querySelectorAll('[data-size-type-radio]');
  if (!radios.length) return;

  function toggleSizeBlocks() {
    var checkedRadio = document.querySelector('[data-size-type-radio]:checked');
    var isCustom = checkedRadio && checkedRadio.value === 'custom';

    // Heading ke bagal "Standard Size" / "Custom Size" text update karo
    var selectedLabelEl = document.querySelector('[data-selected-size-type]');
    if (selectedLabelEl) {
      selectedLabelEl.textContent = isCustom ? 'Custom Size' : 'Standard Size';
    }

    // Dawn ke standard variant-selects wrapper (product-variant-picker.liquid me
    // render hua <variant-selects> custom element) dhoondo.
    var variantSelects = document.querySelector('variant-selects');
    var customBlock = document.querySelector('[data-custom-size-block]');

    if (customBlock) {
      customBlock.style.display = isCustom ? 'block' : 'none';
    }

    if (variantSelects) {
      variantSelects.style.display = isCustom ? 'none' : '';
      // Standard side ke sare selects/radios ko disable/enable karo
      variantSelects.querySelectorAll('select, input[type="radio"]').forEach(function (el) {
        el.disabled = isCustom;
      });
    }

    // Custom side ke fields enable/required karo
    document.querySelectorAll('[data-custom-size-field]').forEach(function (el) {
      el.disabled = !isCustom;
      el.required = isCustom;
    });
  }

  radios.forEach(function (radio) {
    radio.addEventListener('change', toggleSizeBlocks);
  });

  toggleSizeBlocks();
});
